import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ObservationPointVM, SchematicDataVM } from '../../../../../../modules/GET_NEW_UI/setup-implement/setup-implement.model';

@Component({
  selector: 'app-crack-obspoint-schematic',
  templateUrl: './crack-obspoint-schematic.component.html',
  styleUrls: ['./crack-obspoint-schematic.component.scss']
})
export class CrackObspointSchematicComponent implements OnInit {

  @Input() SchematicOP: ObservationPointVM = new ObservationPointVM();
  @Input() schematicData: SchematicDataVM = new SchematicDataVM();
  @Input() isCrack: number;
  mouseoverOP: number = 0
  constructor(private _sanitizer: DomSanitizer, ) { }

  ngOnInit() {
    console.log("schematicOP_",this.SchematicOP)
    console.log("schematicData",this.schematicData)
  }


  getEval() {
  
        return 'red';
    
}
sanitize(image: string) {
  //return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}



getPosition(posX: string, posY: string) {
  var iPX = (parseFloat(posX) / 640.0) * 340;
  var iPY = (parseFloat(posY) / 520.0) * 270;
  return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
}

getLine(posX: string, posY: string,EndposX: string, EndposY: string,isCrackFixed:boolean){
  // bottom right
  var x1 = (parseFloat(posX) / 640.0) * 340
  var y1 = (parseFloat(posY)/ 520.0) * 270;
  // top right
  var x2 = (parseFloat(EndposX) / 640.0) * 340
  var y2 = (parseFloat(EndposY)/ 520.0) * 270;
  // distance
  var length = Math.sqrt(((x2-x1) * (x2-x1)) + ((y2-y1) * (y2-y1)));
  // center
  var cx = (((x1 + x2) / 2) - (length / 2))+7;
  var cy = ((y1 + y2) / 2) - (4 / 2);
  // angle
  var angle = Math.atan2((y1-y2),(x1-x2))*(180/Math.PI);
  // make hr
 var colour =isCrackFixed==false?"#EC0A0A":"#0000FF";
  return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 + 
  'px; background-color:' +colour + '; line-height:1px; position:absolute; left:' + cx + 
  'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');
 
   }

onMouseOverOP(id) {
  this.mouseoverOP = id;
}

onMouseOutOP() {
  this.mouseoverOP = 0;
}
 
}
